import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import makeMemberDialogTemplate from '../../templates/MakeMemberDialog.template.html';

export default angular
  .module('entitiesAdmin.dialogs.MakeMemberDialog', [CSMCommonWeb])
  .service('MakeMemberDialog', Service)
  .name;

/*******************************************************************************
 * Service: MakeMemberDialog
 *
 * Utility to show a dialog make entity an ASB Card holder.
 *******************************************************************************/
/* @ngInject */ function Service($uibModal) {
  /****************************************************************************
   * show */
  /**
   * Show the modal dialog.
   *
   * @param   entityID  ID of entity to be modified.
   * @return            Promise that resolves when the modal dialog is closed.
   ****************************************************************************/
  this.show = function (entityID) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: MakeMemberDialogController,
      size: 'md',
      resolve: {
        entityID: function () {
          return entityID;
        }
      },
      template: makeMemberDialogTemplate
    }).result;
  };
}

/** Dialog Controller. */
/* @ngInject */
var MakeMemberDialogController = function (
  $scope,
  $uibModalInstance,
  BusyScreen,
  BooksSvc,
  entityID
) {
  /** csmValidator properties **/ $scope.valGroup = {};
  /** data object **/ $scope.data = {};

  /***************************************************************************
   * commit */
  /**
   * Click handler for the Ok button. Validates the date, updates the entity
   * with the new ASB card holder date and closes the dialog.
   ***************************************************************************/
  $scope.commit = function () {
    /*------------------*/
    /* Reset validator. */
    /*------------------*/
    $scope.valGroup.reset();

    /*----------------*/
    /* Validate date. */
    /*----------------*/
    if (!$scope.valGroup.validate()) return;

    BooksSvc.makeMember(entityID, $scope.data.date).then(
      function () {
        $uibModalInstance.close();
      },
      /*-----------------------------*/
      /* Service call error handler. */
      /*-----------------------------*/
      function (resp) {
        Alert.error(
          resp.parsedResponse.message(),
          'Make ASB Card Holder Error'
        );
      }
    );
  };
};
